<template>
	<div>
		<b-img src="/images/importer/module-expressions/expressions.jpg"></b-img>
		<p>
			The Expressions module is for assigning animations to the various expressions and emotes that your character can display in-game, as well as a few other animations like breast scaling.
			Keep in mind that the character's limbs are controlled by in-game IK rigs for the main animations, so these expressions will not be able to affect the arms, legs, head, or the fingers
			- they're mainly intended for facial expressions and other utility functions.
		</p>

		<p>
			Note: Any animation keys in any expression animations will prevent the corresponding position/rotation of an object from being affected by physics in Unity. So for example, the cock unsheath
			animation should only reference some bone in the cock base (or a parent of it), or else that bone will be fixed in the orientation set by the animation and not able to be driven by physics 
			like it normally would.
		</p>
        
		<p>
			The module groups the animations by "Looping" and "Emote" expression types, but there is also some layering of animations that happens within the Looping expressions, which will be noted
			below.
		</p>

		<h4 class="mt-5">Looping Expressions</h4>
		<p>
			<span class="font-weight-bold">Base Idle Animation:</span> This animation loop plays at all times, and is the lowest "layer" of animation - any changes to bones made by other animations will 
			override keys in this one. This animation is useful for setting a rest pose for your character if it needs to be different from the t-pose, such as keeping your character's wings folded.
		</p>
        
		<p>
			<span class="font-weight-bold">Breathing:</span> This is a "relaxed" idle animation - it plays at all times except when the Sleeping or Low/Medium/High Arousal animations are playing. For Feral 
			characters, this is treated a little differently and plays at all times, with those other animations layered on top.
		</p>
        
		<p>
			<span class="font-weight-bold">Sleeping:</span> This expression loop plays when sleeping.
		</p>
        
		<p>
			<span class="font-weight-bold">Rimming:</span> This expression loop plays when rimming or eating out your partner, or during facesitting.
		</p>
        
		<p>
			<span class="font-weight-bold">Sucking Cock:</span> This expression loop plays when sucking your partner's cock. This is intended to be for the facial/eye expressions during this activity - the
			"Mouth Open" animation is layered on top of this one to handle the jaw opening.
		</p>

		<p>
			<span class="font-weight-bold">Mouth Open:</span> This expression loop plays when sucking your partner's cock, during Skin Edit mode when the "Open Mouth" action is selected, and during mawplay 
			for Feral characters. The jaw should be opened wide enough for your character to suck your partner's cock.
		</p>
        
		<p>
			<span class="font-weight-bold">Low/Medium/High Arousal:</span> These expression loops play based on the character's current arousal level. The actual expression that plays based on arousal is 
			random, but a higher arousal will make the medium or high arousal animations play more frequently.
		</p>
        
		<p>
			<span class="font-weight-bold">Receiving Scritches (Feral Only):</span> This expression loop plays during the "Petting" action in desktop mode, or when a character's hands are within a scritch 
			zone on this character when in VR mode.
		</p>

		<h4 class="mt-5">Emotes</h4>
		<p>
			These animations are played in specific instances, and are intended to be a one-time (not looping) animation that is layered on top of the current looping animation.
		</p>

		<p>
			<span class="font-weight-bold">Gasp or Moan:</span> This list of emotes play randomly during any sex position that doesn't involve the character's mouth.
		</p>

		<p>
			<span class="font-weight-bold">Snarl, Smile, Playful, Yawn:</span> These emotes can be triggered by animation events in the Interaction Studio.
		</p>

		<p>
			<span class="font-weight-bold">Bark or Attract:</span> This emote plays when this character's AI is trying to get the player's attention.
		</p>

		<p>
			<span class="font-weight-bold">Close Left/Right Eye:</span> These animations are played when one of the character's hands gets too close to this character's eye. The animation should start 
			with the eyelids opened and end with them fully closed.
		</p>

		<h4 class="mt-5">Other Expression Animations</h4>
		<p>
			These animations are used for various utility functions and situations that don't fit into the Looping or Emote categories.
		</p>

		<p>
			<span class="font-weight-bold">Belly Inflation:</span> This animation controls the character's belly inflation from fluids, if this has been enabled by the player in the game's Preferences. 
			Generally, this involves animating a blendshape of the character's belly inflating, but should also include scaling a collider or colliders to fit the belly's new shape, if colliders are 
			used for this character. The game currently supports two "maximum" inflation levels - Limited or Full. The animation should start at no inflation on the first frame, hit the threshold 
			used for the Limited setting at halfway through the animation, and end the animation at the maximum value for Full.
		</p>

		<p>
			<span class="font-weight-bold">Knot or Flare Swell:</span> If this character has a cock with a knot and/or flare that swells during orgasm, this animation should be set to enable this effect. 
			The animation should start with the knot/flare at a normal state, and end with it in a fully swollen state.
		</p>

		<p>
			<span class="font-weight-bold">Orgasm Pulse:</span> This should be a short animation that will play in time with cum / orgasm during a character's climax, such as balls clenching etc.
		</p>

		<p>
			<span class="font-weight-bold">Cock Unsheath:</span> If this character has a Cock with a sheathed state, this animation should be set to control the unsheathing. The animation should start with 
			the cock fully sheathed and end with the cock fully unsheathed. Keep in mind that referencing any bones in an animation prevents those bones from being controlled by physics in Unity - 
			be sure to only animate keys for the root bone of the cock, or a parent of it, when making this animation, so the rest of the cock bones can be controlled by physics.
		</p>

		<p>
			<span class="font-weight-bold">Breast Scale:</span> If this character has breasts that support scaling, this expression will control the scale. The animation should start at the minimum size and 
			end at the maximum size.
		</p>

		<p>
			<span class="font-weight-bold">Cock Scale:</span> If this character has a cock that support scaling, this expression will control the scale. The animation should start at the minimum size and 
			end at the maximum size.
		</p>

		<p>
			<span class="font-weight-bold">Ball Scale:</span> If this character has balls that support scaling, this expression will control the scale. The animation should start at the minimum size and 
			end at the maximum size.
		</p>

		<p>
			<span class="font-weight-bold">Toggle Muzzle:</span> Defining an expression here will make the "Toggle Muzzle" option appear in the Character Menu. This animation is used when in first-person 
			or VR mode for hiding parts of the player's head so they aren't visible. Only the first and last frames of the animation are used since it is a toggle and not an animation that is played - 
			the first frame should have the muzzle hidden, and the last frame should have it visible.
		</p>
        
		<p>
			<span class="font-weight-bold">Finger Curl:</span> For Feral characters, this animation is used to set the open and closed poses for the hands. The first frame of the animation should
			have the hand open in its default pose, and the last frame should have the fingers curled into a fist. The intermediate frames are not used.
		</p>
	</div>
</template>

<script>
export default {
		name: 'ExpressionsModule',
}
</script>
